module.exports = __webpack_public_path__ + "static/media/29DUNON1.1db980f8.jpg";